import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AdministrationBean } from '../model/AdministrationBean';
import { AdministrationService } from '../services/administration-service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ServiceType } from 'src/app/shared/Enums';


@Component({
  selector: 'app-edit-inref',
  templateUrl: './edit-inref.component.html',
  styleUrls: ['./edit-inref.component.css'],
  providers: [{
    provide: MAT_RADIO_DEFAULT_OPTIONS,
    useValue: { color: '#0071EB' },
}]
})
export class EditInrefComponent {

  @Input() infRef: AdministrationBean;
  @Input() newInref: boolean;
  @Input() isSupportAdmin: boolean;
  @Input() isSuperAdmin: boolean;
  changedDate: Date;
  infRefLocal= new AdministrationBean();
  profileForm: any;
  isDisabled : boolean;
  types: Types[];
  constructor(private adminService: AdministrationService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder){}

  ngOnInit() {
    this.types=[
      { label: ServiceType.FILSERVICE, value: 'FILSERVICE' },
    ];
    this.isDisabled = !this.newInref;
    if(!this.newInref) {
       this.profileForm = this.fb.group({
        firstName: ['', Validators.required ],
        type: [{value: '', disabled: false}, Validators.required ],
        routeType: [{value: "EXPLICIT", disabled: !this.newInref}, Validators.required ],
        automaticActivation: "",
        comment: ""
        });
    } else {
      this.profileForm = this.fb.group({
        firstName: ['', Validators.required ],
        type: [{value: '', disabled: false}, Validators.required ],
        routeType: [{value: "EXPLICIT", disabled: false}, Validators.required ],
        automaticActivation: "",
        comment: ""
        });
    }
  }

  ngOnChanges() {
    if(this.infRef?.uuid && !this.infRefLocal.uuid) {
      this.infRefLocal = { ...this.infRef };
    } else {
      this.infRefLocal.automaticActivationFlag = false;
      this.infRefLocal.routingType = 'EXPLICIT';
      this.infRef.automaticActivationFlag = false;
      this.infRef.routingType = 'EXPLICIT';
    }
    this.adminService.infrefLocal = this.infRefLocal;
    if(!this.isSupportAdmin && !this.isSuperAdmin) {
      this.profileForm.disable();
    }
  }

  @Output() cancelClickEvent = new EventEmitter<boolean>();
  @Output() submitClickedEvent = new EventEmitter<boolean>();
  submitClicked() {
    this.profileForm.controls.firstName.markAsDirty();
    this.profileForm.controls.type.markAsDirty();
    this.profileForm.markAllAsTouched();

    if (
      this.infRefLocal.infRefName == undefined ||
      this.infRefLocal.infRefName == "" ||
      this.infRefLocal.routingType == undefined ||
      this.infRefLocal.serviceType == undefined ||
      this.infRefLocal.automaticActivationFlag == undefined
    ) {
      this.showError('Field Data missing.');
      return;
    }
    delete this.infRefLocal.flagString;
    if(this.infRefLocal.uuid) {
      this.adminService.updateInfref(this.infRefLocal).then(data => {
        this.submitClickedEvent.emit(true);
      },error=>{
        this.showError(error.error.errorMessage);
      })
    } else {
      this.adminService.addInfRef(this.infRefLocal).then(data =>{
        this.submitClickedEvent.emit(true);
      },error=>{
        this.showError(error.error.errorMessage);
      })
    }
  }

  cancelClick() {
    if (
      JSON.stringify(this.infRef) === JSON.stringify(this.infRefLocal)
    ) {
      this.cancelClickEvent.emit(true);
      this.infRefLocal= {};
    } else {
      this.confirmationService.confirm({
        message:
          'Du er ved at navigere væk fra en side med ændrede data uden at gemme først. Ønsker du at fortsætte?',
        header: 'Ændringer er ikke gemt',
        rejectLabel: 'Nej',
        acceptLabel: 'Ja',

        accept: () => {
          this.cancelClickEvent.emit(true);
          this.infRefLocal= {};
          this.adminService.infrefLocal = {
            "automaticActivationFlag"
              :
              false,
            "routingType"
              :
              "EXPLICIT"
          };
        },
      });
    }
  }

  showError(error: any) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: error,
      life: 3000,
    });
  }
}

interface Types {
  label: string;
  value: string;
}
